module.exports = __webpack_public_path__ + "img/marker_current_location.09fc9b5c.svg";